import { useState } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { ZepLogoTightIcon } from '@zep/icons';
import { heroServiceButtons } from '../../../../consts/landingConsts';
import { HeroVideo } from './HeroVideo';
import { ServiceButton } from './ServiceButton';
export const LandingHero = () => {
  const [activeServiceIndex, setActiveServiceIndex] = useState(0);
  const {
    t
  } = useTranslation(['home']);
  const handleVideoEnded = () => {
    setActiveServiceIndex(prev => (prev + 1) % heroServiceButtons.length);
  };
  return <section className="relative min-h-[548px] w-full py-quiz-2xl tablet:min-h-[934px] tablet:py-quiz-4xl lg:min-h-[1141px]" data-sentry-component="LandingHero" data-sentry-source-file="LandingHero.tsx">
      <div className="absolute inset-x-0 top-0 h-[417px] bg-gradient-to-r from-quiz-purple-400/25 to-quiz-blue-400/25 tablet:h-[744px]" />
      <div className="absolute inset-x-0 top-0 h-[417px] bg-gradient-to-b from-quiz-white to-transparent tablet:h-[620px]" />

      <div className="relative z-10">
        <div className="flex flex-col items-center gap-quiz-xl text-center">
          <h1 className="flex flex-col items-center gap-quiz-sm text-[34px] font-[800] leading-[31.2px] text-quiz-gray-900 tablet:gap-quiz-2xs tablet:leading-[44.2px] lg:gap-quiz-md lg:text-[64px] lg:leading-[62.4px]">
            <span>{t('home:landing.hero.title')}</span>
            <span className="flex items-center justify-center gap-quiz-2xs">
              <Trans t={t} i18nKey="home:landing.hero.subtitle" components={{
              Logo: <ZepLogoTightIcon className="h-[26px] w-auto tablet:h-[30px] lg:h-[53px]" />
            }} data-sentry-element="Trans" data-sentry-source-file="LandingHero.tsx" />
            </span>
          </h1>
          <p className="text-[13px] font-[600] leading-[18.2px] text-quiz-gray-700 tablet:text-[19px] tablet:font-[500] tablet:leading-[21px] lg:text-[20px] lg:leading-[22.4px]">
            {t('home:landing.hero.description')}
          </p>
        </div>

        <div className="flex items-center justify-center gap-quiz-3xs pb-quiz-md pt-quiz-xl tablet:gap-quiz-sm tablet:pb-quiz-xl tablet:pt-quiz-3xl">
          {heroServiceButtons.map(button => <ServiceButton key={button.id} label={button.label} isActive={activeServiceIndex === button.id} onClick={() => setActiveServiceIndex(button.id)} />)}
        </div>
      </div>
      <div className="pt-quiz-sm">
        <HeroVideo activeServiceIndex={activeServiceIndex} onVideoEnded={handleVideoEnded} data-sentry-element="HeroVideo" data-sentry-source-file="LandingHero.tsx" />
      </div>
    </section>;
};